<script setup lang="ts">
import dayjs from '@sancare/typescript-commons/src/misc/dayjs'
import { computed } from 'vue'

import { useStayTrail } from '@/breadcrumbs/useStayTrail'

interface ChronicJustification {
  id: number
  rssId: string | null
  stayEnd: string
  stayDuration: number
}

defineProps<{
  title: string
  chronicJustifications: ChronicJustification[]
}>()

const stayTrail = useStayTrail()
const stayLinkQuery = computed(() => stayTrail.stayLinkQuery())

function formatDate(date: string): string {
  return dayjs(date).format('L')
}
</script>

<template>
  <div class="justification-popover">
    <div
      v-if="chronicJustifications.length"
      class="justification-part"
    >
      <h3
        class="btn btn-sm btn-report-select"
      >
        {{ title }}
      </h3>
      <div class="justification-part-line mb-2 fw-bold">
        <div class="row mx-1 popover-report-content align-items-center">
          <span class="col-3">Date de fin</span>
          <div>
            <span class="col-4">Rss id</span>
            <span class="col-2">Durée du séjour</span>
            <span class="col-3" />
          </div>
        </div>
      </div>
      <div
        v-for="chronicJustification in chronicJustifications"
        :key="chronicJustification.id"
        class="justification-part-line"
      >
        <div class="row mx-1 popover-report-content align-items-center">
          <span class="col-3">
            {{ chronicJustification.stayEnd ? formatDate(chronicJustification.stayEnd) : '-' }}
          </span>
          <div class="hinted-summary-line">
            <router-link :to="{name: 'mco-stay', params: {stayId: chronicJustification.id, idType: 'id'}, query: stayLinkQuery }">
              <span class="col-4">
                {{ chronicJustification.rssId ? chronicJustification.rssId : chronicJustification.id }}
              </span>
              <span class="col-2">
                {{ typeof chronicJustification.stayDuration !== 'undefined' ? chronicJustification.stayDuration + 'j' : '-' }}
              </span>
              <span class="col-3" />
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="loader loader-center mb-4" />
      <p class="">
        Chargement des justifications...
      </p>
    </div>
  </div>
</template>
